import api, { Base } from 'ev-api/api';

import type { AccessVerificationParams } from './params';

const cdxAccessVerificationApi = api.injectEndpoints({
  endpoints: builder => ({
    verifyUserAccess: builder.mutation<void, AccessVerificationParams>({
      query: ({ validationTag, practiceId, userId, frontDoorId, data }) => ({
        url: `${Base.V4}/cdx_proxy/sync_event`,
        method: 'POST',
        body: {
          entity: 'access_verification',
          event: 'access_verification',
          correlation_id: crypto.randomUUID(),
          verification_tag: validationTag,
          practice_id: practiceId,
          data: {
            ...data,
            user_id: userId,
            resource: 'patient_identity_verification',
            action: 'verify',
            context: {
              timestamp: new Date().toISOString(),
              verification_purpose: 'patient_registration',
              request_source: `front_door_${frontDoorId}`,
            },
          },
        },
      }),
    }),
  }),
});

export const { useVerifyUserAccessMutation } = cdxAccessVerificationApi;
